import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioSeeAllApi = createApi({
  reducerPath: 'audioSeeAllPageApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioSeeAllPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  tagTypes: ['AudioSeeAll'],
  endpoints: (builder) => ({
    fetchAudioSeeAllData: builder.query({
      query: (option) => ({
        url: 'https://apiv2.shwenarsin.com/api/app/homecategory/seeallv2',
        method: 'POST',
        body: {
          "category_id": option.category_id || option,
          "phone": "",
          "platform": "miniapp",
          "udid": "",
          "user_id": getLocalStorageData(),
          "version_code": 29,
          "version_name": "1.2.9",
          "page_no": option.page || 1
        },
      }),
      // Cache data for 5 minutes
      keepUnusedDataFor: 300,
      // Transform response to normalize data
      transformResponse: (response, meta, arg) => {
        return {
          ...response,
          currentPage: arg.page || 1,
          categoryId: arg.category_id || arg
        };
      },
      // Provide cache tags for efficient invalidation
      providesTags: (result, error, arg) => [
        { type: 'AudioSeeAll', id: 'LIST' },
        { type: 'AudioSeeAll', id: `${arg.category_id || arg}-${arg.page || 1}` }
      ],
      // Merge pages for infinite scroll (optional advanced feature)
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}-${queryArgs.category_id || queryArgs}`;
      },
      merge: (currentCache, newItems, { arg }) => {
        if (arg.page === 1) {
          return newItems;
        }
        return {
          ...newItems,
          result: [...(currentCache.result || []), ...(newItems.result || [])],
        };
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page;
      },
    }),
    
    // Optional: Add a separate endpoint for refreshing data
    refreshAudioSeeAllData: builder.mutation({
      query: (categoryId) => ({
        url: 'https://apiv2.shwenarsin.com/api/app/homecategory/seeallv2',
        method: 'POST',
        body: {
          "category_id": categoryId,
          "phone": "",
          "platform": "miniapp",
          "udid": "",
          "user_id": getLocalStorageData(),
          "version_code": 29,
          "version_name": "1.2.9",
          "page_no": 1
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'AudioSeeAll', id: 'LIST' },
        { type: 'AudioSeeAll', id: `${arg}-*` }
      ],
    })
  }),
});

export const { 
  useFetchAudioSeeAllDataQuery, 
  useRefreshAudioSeeAllDataMutation 
} = audioSeeAllApi;